'use es6';

import { Loadable } from 'foundations-components/transitional/utils/Loadable';
const loader = () => import( /* webpackChunkName: "rename-dashboard-dialog" */'dashboard-components/dashboard-actions/prompts/RenameDashboardDialogContainer').then(module => module.RenameDashboardDialogContainer);
export default Loadable({
  loader,
  LoadingComponent: () => null
});